(function() { window.GUID_38723f40_c4a6_4ebc_8238_9266e2bc9511 = { getGuid: function() { return "38723f40-c4a6-4ebc-8238-9266e2bc9511"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class popupwizard_sportevent_fees_select_players extends Controls.PopupWizardStep {
            constructor() {
                super(...arguments);
                this.NextStep = "select-fees";
            }
            OnCheckIfCanContinue() {
                let checked = this.$StepDiv.find("input:checked");
                return checked.length !== 0;
            }
            OnSubmit() {
                let ids = this.$StepDiv.find("input[name^='player_']:checked").map((i, e) => { return e.name.split('_').pop().split('.'); }).get();
                let $PlayerIds = this.$StepDiv.find("#PlayerIds");
                $PlayerIds.val(ids.join(','));
            }
        }
        Controls.popupwizard_sportevent_fees_select_players = popupwizard_sportevent_fees_select_players;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=select-players.js.map
